import { Settings } from "@mui/icons-material";
import { Box, Container } from "@mui/material";
import GlobalNavigation from "../../components/GlobalNavigation";
import Header from "../../components/Header";
import Helmet from "../../components/Helmet";
import Layout, {
  LayoutStateProvider,
  SidebarSwitch,
  SideSheetTrigger,
} from "../../components/Layout";
import SettingsDrawer from "../../components/SettingsDrawer";
import { CreateForm } from "./components/CreateForm";

export function NewApiKey() {
  return (
    <>
      <Helmet>
        <title>New API Key</title>
      </Helmet>
      <LayoutStateProvider>
        <Layout
          header={
            <Header
              title="New API Key"
              actions={
                <SideSheetTrigger
                  title="Settings"
                  sidebarId="settings"
                  icon={<Settings />}
                />
              }
            />
          }
          globalNavigation={<GlobalNavigation />}
          sideSheet={
            <SidebarSwitch
              config={[
                {
                  id: "settings",
                  element: <SettingsDrawer />,
                },
              ]}
            />
          }
        >
          <Box sx={{ flexGrow: 1, minWidth: 0, overflowY: "auto", py: 4 }}>
            <Container fixed>
              <CreateForm />
            </Container>
          </Box>
        </Layout>
      </LayoutStateProvider>
    </>
  );
}
